import { Card } from 'antd'
import { AnalysesData, AnalysesDataContainer, CardTitle } from './style'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'

interface AnalysesProps {
  client?: any; // Client data from GET_PROFESSIONAL_CLIENT query
}

const Analyses = ({ client }: AnalysesProps) => {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);
  
  // Extract analyses data from the client object
  // The GET_PROFESSIONAL_CLIENT query returns all analyses data
  const hmaData = client?.hairAndMineralAnalyses?.filter((item: any) => item.professionalViewable || item.clientViewable) || [];
  const hrvData = client?.heartRateVariabilities?.filter((item: any) => item.professionalViewable || item.clientViewable) || [];
  const irCombiData = client?.irCombis?.filter((item: any) => item.professionalViewable || item.clientViewable) || [];
  const iodineData = client?.iodineTests?.filter((item: any) => item.clientViewable) || [];
  
  console.log('Analyses component - Client data:', client);
  console.log('Analyses data extracted:', {
    hma: hmaData,
    hrv: hrvData,
    irCombi: irCombiData,
    iodine: iodineData
  });

  // Get the professional code from the client data
  const professionalCode = client?.professionalCode;
  
  console.log('Professional code for navigation:', professionalCode);

  const handleAnalysisClick = (type: string, items: any[]) => {
    if (items.length === 0) {
      console.log('No analyses available for:', type);
      return;
    }

    // If there's only one item, navigate directly to it
    if (items.length === 1) {
      const item = items[0];
      let path = '';
      
      switch (type) {
        case 'hma':
          path = `/p/${professionalCode}/hma_results/${item.id}`;
          break;
        case 'hrv':
          path = `/p/${professionalCode}/hrv_reports/${item.id}`;
          break;
        case 'irCombi':
          path = `/p/${professionalCode}/ir_combis/${item.id}`;
          break;
        case 'iodine':
          path = `/p/${professionalCode}/iodine_tests/${item.id}`;
          break;
      }
      
      console.log('Navigating to:', path);
      navigate(path);
    } else {
      // Multiple items - navigate to the first one for now
      // TODO: Could show a modal/list to choose which one
      const item = items[0];
      let path = '';
      
      switch (type) {
        case 'hma':
          path = `/p/${professionalCode}/hma_results/${item.id}`;
          break;
        case 'hrv':
          path = `/p/${professionalCode}/hrv_reports/${item.id}`;
          break;
        case 'irCombi':
          path = `/p/${professionalCode}/ir_combis/${item.id}`;
          break;
        case 'iodine':
          path = `/p/${professionalCode}/iodine_tests/${item.id}`;
          break;
      }
      
      console.log('Multiple items available, navigating to first:', path);
      navigate(path);
    }
  };

  const analysesLists = [
    {
      id: 1,
      type: 'hma',
      title: 'Hair and Mineral analysis',
      status: hmaData.length > 0 ? `${hmaData.length} available` : 'Not available yet',
      count: hmaData.length,
      data: hmaData
    },
    {
      id: 2,
      type: 'hrv',
      title: 'Heart Rate Variability',
      status: hrvData.length > 0 ? `${hrvData.length} available` : 'Not available yet',
      count: hrvData.length,
      data: hrvData
    },
    {
      id: 3,
      type: 'irCombi',
      title: 'IR Combi',
      status: irCombiData.length > 0 ? `${irCombiData.length} available` : 'Not available yet',
      count: irCombiData.length,
      data: irCombiData
    },
    {
      id: 4,
      type: 'iodine',
      title: 'Iodine Test',
      status: iodineData.length > 0 ? `${iodineData.length} available` : 'Not available yet',
      count: iodineData.length,
      data: iodineData
    },
    {
      id: 5,
      type: 'nitrate',
      title: 'Nitrate / nitrite saliva test',
      status: 'Not available yet',
      count: 0,
      data: []
    },
  ];

  return (
    <Card>
      <CardTitle>
        <p>Analyses</p>
      </CardTitle>
      <AnalysesDataContainer>
        {analysesLists.map((analyses) => (
          <AnalysesData 
            key={analyses.id}
            onClick={() => handleAnalysisClick(analyses.type, analyses.data)}
            style={{ 
              cursor: analyses.count > 0 ? 'pointer' : 'default',
              opacity: analyses.count > 0 ? 1 : 0.6,
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              if (analyses.count > 0) {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <p>{analyses.title}</p>
            <small>{analyses.status}</small>
          </AnalysesData>
        ))}
      </AnalysesDataContainer>
    </Card>
  )
}

export default Analyses